// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHomeIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m20.708 11.293-8-7.997a1 1 0 0 0-1.42 0l-8 7.997a1 1 0 0 0-.21 1.09 1 1 0 0 0 .92.62h1V20a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-5.998h4V20a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-6.997h1a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09" />
  </g>
);
export default SvgHomeIcon;
SvgHomeIcon.displayName = 'SvgHomeIcon';
